import { render, staticRenderFns } from "./BlackListSet.vue?vue&type=template&id=50d94581&scoped=true"
import script from "./BlackListSet.vue?vue&type=script&lang=js"
export * from "./BlackListSet.vue?vue&type=script&lang=js"
import style0 from "./BlackListSet.vue?vue&type=style&index=0&id=50d94581&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d94581",
  null
  
)

export default component.exports